import { createApi } from '@reduxjs/toolkit/query/react';
import { saveAs } from 'file-saver';
import { createBaseQuery, toQueryParams } from 'helpers/api';
import { stringDate } from 'helpers/date';

export const auditLogsApi = createApi({
  reducerPath: 'auditLogsApi',
  baseQuery: createBaseQuery('audit_logs', { timeout: 0 }),
  endpoints: builder => ({
    getAuditLogs: builder.query({
      query: params => `?${toQueryParams(params)}`,
      transformResponse: ({ result }) => result,
    }),
    downloadAuditLogs: builder.query({
      queryFn: async (_, api, extraOptions, baseQuery) => {
        const { data: file } = await baseQuery({
          url: '/download',
          responseHandler: async response => {
            const blob = await response.blob();
            return blob;
          },
          cache: 'no-cache',
        });
        saveAs(file, `${stringDate()}_audit_logs`);
        return { data: null };
      },
    }),
  }),
});

export const { useLazyGetAuditLogsQuery, useLazyDownloadAuditLogsQuery } = auditLogsApi;
